<template>
<div :key="$store.getters['resource/currentResource'].key">
  <help :text="$t('help.plan')" :title="$t('help.history_title')"/>
  <p>Plan ID: {{ id }}</p>
  <v-server-table
      ref="appTable"
      name="historyTable"
      :url="`/admin/predictive-paywall/actions?plan_id=${id}`"
      :columns="columns"
      :options="options"
      @loaded="loading = false"
      @loading="loading = true"
      class="white-container"
  >
    <template slot="beforeFilter">
    </template>
    <template slot="beforeLimit" v-if="totalRecordsCount > 10">
      {{$t('global.showing')}}&nbsp;
    </template>
    <template slot="afterLimit" v-if="totalRecordsCount > 10">
      &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
    </template>
    <template slot="is_shown_paywall_calculated" slot-scope="props">
      <column-check :row="props.row" column="is_shown_paywall_calculated" />
    </template>
    <template slot="is_shown_paywall" slot-scope="props">
      <column-check :row="props.row" column="is_shown_paywall" />
    </template>
    <template slot="propensity_rank_total" slot-scope="props">
      {{ Number(props.row.propensity_rank_total).toFixed(3) }}
    </template>
    <template slot="propensity_rank_content" slot-scope="props">
      {{ Number(props.row.propensity_rank_content).toFixed(3) }}
    </template>
    <template slot="propensity_rank_user" slot-scope="props">
      {{ Number(props.row.propensity_rank_user).toFixed(3) }}
    </template>
    <template slot="propensity_rank_median" slot-scope="props">
      {{ Number(props.row.propensity_rank_median).toFixed(3) }}
    </template>
    <template slot="payload" slot-scope="props">
      <b-button
          variant="primary"
          size="sm"
          @click="openModal(props.row.payload)"
      >
        {{ $t('history.view_details') }}
      </b-button>
    </template>

  </v-server-table>
  <b-modal
      id="jsonModal"
      :visible="isModalVisible"
      @hide="closeModal"
      title="Payload details"
      size="lg"
      centered
      modal-class="payload-modal"
  >
<!--    <pre class="mb-0">{{ formatNestedObject(modalData) }}</pre>-->
    <div v-html="convertJsonToHtml(modalData)"></div>
    <template #modal-footer>
      <b-button variant="secondary" @click="closeModal">
        {{ $t('history.close') }}
      </b-button>
    </template>
  </b-modal >
</div>
</template>

<script>
import axios from '@/utils/axios';
import {Event} from 'vue-tables-2';
import i18n from "@/utils/i18n";
export default {
  middleware: 'auth',
  name: "PredictivePaywallHistory",
  data: () => {
    return {
      loading: false,
      totalRecordsCount: null,
      isModalVisible: false,
      modalData: null,
      params: {
        page: 1,
        filter: {}
      },
      columns: ['id', 'content_type_id', 'taxonomy_term_id', 'content_id', 'user_id', 'session_id', "propensity_rank_content", "propensity_rank_user", "propensity_rank_total", "propensity_rank_median", "propensity_rank_percent", "is_shown_paywall_calculated", "is_shown_paywall", "payload", "created_at"],
      options: {
        skin: [],
        headings: {
          id: i18n.t('history.id'),
          content_type_id: i18n.t('history.content_type_id'),
          taxonomy_term_id: i18n.t('history.taxonomy_term_id'),
          content_id: i18n.t('history.content_id'),
          user_id: i18n.t('history.user_id'),
          session_id: i18n.t('history.session_id'),
          propensity_rank_content: i18n.t('history.propensity_rank_content'),
          propensity_rank_user: i18n.t('history.propensity_rank_user'),
          propensity_rank_total: i18n.t('history.propensity_rank_total'),
          propensity_rank_median: i18n.t('history.propensity_rank_median'),
          propensity_rank_percent: i18n.t('history.propensity_rank_percent'),
          is_shown_paywall_calculated: i18n.t('history.is_shown_paywall_calculated'),
          is_shown_paywall: i18n.t('history.is_shown_paywall'),
          payload: i18n.t('history.payload'),
          created_at: i18n.t('history.created_at'),
        },
        sortable: [],
        filterByColumn: false,
        columnsDropdown: false,
        customFilters: ['custom'],
        perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
        filterable: false,
        // requestFunction: (data) => {
        //   localStorage.setItem('perPage', data.limit);
        //   return axios.get(`admin/predictive-paywall/actions?&plan_id=${this.id}`, {
        //     params: {
        //       order: 'active',
        //       sort: 'desc',
        //       limit: data.limit,
        //       filter: data.custom,
        //       page: data.page
        //     }
        //   }).catch((e) => {
        //     // this.$noty.error(e.error_description);
        //     this.dispatch('error', e);
        //   });
        // },
        requestFunction: function (data) {
          // console.log("Request params:", this.id);
          // console.log("Request params (data):", data);
          console.log("URL:", this.url);
          localStorage.setItem('perPage', data.limit);
          return axios.get(this.url, {
            params: {
              // plan_id: this.id,
              // filter: data.custom,
              limit: data.limit,
              page: data.page,
            }
          }).then((response) => {
            return response;
          }).catch((e) => {
            // this.$noty.error(e.error_description);
            this.dispatch('error', e);
          });
        },
        responseAdapter: function (resp) {
          let data = this.getResponseData(resp);
          return {
            data: data.data.items,
            count: data.data.paginator.total_items
          }
        }
      },
    }
  },
  props: {

  },
  computed: {
    id() {
      return this.$route.params.id || "";
    },
  },
  methods: {
    openModal(data) {
      this.modalData = data;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      this.modalData = null;
    },
    // formatNestedObject(data) {
    //   if (!data) return this.$t('history.no_data');
    //   try {
    //     return JSON.stringify(data, null, 2);
    //   } catch (e) {
    //     console.error("Error formatting data:", e);
    //     return this.$t('history.invalid_data');
    //   }
    // }

    convertJsonToHtml(data) {
      if (!data) return `<p>${this.$t('global.no_data')}</p>`;
      if (typeof data !== 'object') return `<span>${data}</span>`;

      let html = '<ul>';
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          html += `<li><strong>${key}:</strong> `;
          if (typeof data[key] === 'object') {
            html += this.convertJsonToHtml(data[key]);
          } else {
            html += `${data[key]}`;
          }
          html += '</li>';
        }
      }
      html += '</ul>';
      return html;
    }
  },
  created() {
    if (!this.id) {
      this.$router.push({path: "/plans"});
    } else {
      // this.fetchScheduleData();
    }
  },
  mounted() {
    Event.$on('vue-tables.historyTable.loaded', ({data}) => {
      this.totalRecordsCount = data.paginator.total_items
    });
  },
  destroyed() {
    Event.$off('vue-tables.historyTable.loaded');
  }
}
</script>

<style scoped>

</style>
